module.exports = __webpack_public_path__ + "static/008414-365b9eed8357c240c3c16b3e59ab34d9.jpg";